import { useHistory } from "react-router-dom";

function Success() {
  const history = useHistory();
  return (
    <div>
      <h1>Transaction success</h1>
      <button
        onClick={() => {
          history.push("/");
        }}
      >
        Go to Home
      </button>
    </div>
  );
}

export default Success;
